import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets//images/joyworks_logo2.png'
import _imports_1 from '../assets/images/clothes.png'
import _imports_2 from '../assets/images/status.png'
import _imports_3 from '../assets/images/login_enter.png'


const _withScopeId = n => (_pushScopeId("data-v-86f3023a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity_wrapper" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    calss: "img_logo",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "section1_text" }, [
    /*#__PURE__*/_createTextVNode("조이웍스"),
    /*#__PURE__*/_createElementVNode("span", { class: "text_highLight" }, "A/S 온라인 신청서")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img_text" }, "수선등록", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img_text" }, "상태조회", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img_text" }, "로그아웃", -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

import authAPI from "@/api/authAPI";
import router from "@/router";
import { onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientHome',
  setup(__props) {

onMounted(() => {
  checkSession();
});
const checkSession = () => {
  authAPI
    .checkSession()
    .then((res: any) => {
      console.log(res);
      const data = res.data.data;
      if (data.result == "FAIL") {
        router.push({ name: "clientLogin" });
      }
    })
    .catch((error: any) => {
      console.log(error);
      alert(error);
    });
};

const logout = () => {
  window.customConfirm({
    title: "로그아웃",
    msg: "로그아웃 하시겠습니까?",
    sCb: () => {
      authAPI.logout().then(() => {
        router.push({ name: "clientLogin" });
      });
    },
  });
};

const registPage = () => {
  router.push({ name: "clientRegist" });
};

const detailListPage = () => {
  router.push({ name: "clientDetailList" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", { class: "form_container" }, [
      _hoisted_4,
      _createElementVNode("div", { class: "section2" }, [
        _createElementVNode("div", {
          onClick: registPage,
          class: "img_box"
        }, _hoisted_7),
        _createElementVNode("div", {
          onClick: detailListPage,
          class: "img_box"
        }, _hoisted_10)
      ]),
      _createElementVNode("div", { class: "section3" }, [
        _createElementVNode("div", {
          class: "img_box logout_box",
          onClick: logout
        }, _hoisted_13)
      ])
    ])
  ]))
}
}

})